import React from 'react';
import { History } from 'history';
import classNames from 'classnames';
import { Breadcrumb as AntDBreadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import { ArrowLeft } from 'Icons';
import { Button } from 'components/AntD';
import Separator from './Separator';

import './styles.less';

export interface BreadCrumbItem {
  label: React.ReactNode;
  link?: string;
  onClick?(): void;
}
interface BreadCrumbsProps {
  history: History;
  breadCrumbs: Array<BreadCrumbItem>;
  className?: string;
  onClick?(): void;
}

export default function Breadcrumb({
  history,
  breadCrumbs,
  className = '',
  onClick = history ? history.goBack : () => void 0,
}: BreadCrumbsProps): JSX.Element {
  return (
    <div
      className={classNames(
        'sl-breadcrumbs tw-flex tw-items-center tw-flex-nowrap tw-grow tw-gap-2',
        className
      )}
    >
      <Button variant="text" size="small" icon={<ArrowLeft />} onClick={onClick} />
      <div className="tw-flex-grow tw-min-w-0">
        <AntDBreadcrumb className="tw-flex tw-flex-nowrap" separator={<Separator />}>
          {breadCrumbs.map(({ label, link, onClick }, idx) => (
            <AntDBreadcrumb.Item key={idx} onClick={onClick} className="tw-text-xs">
              {link ? <Link to={link}>{label}</Link> : label}
            </AntDBreadcrumb.Item>
          ))}
        </AntDBreadcrumb>
      </div>
    </div>
  );
}
